import { render } from 'preact';
import { ExifComponent } from "../metadata/ExifComponent";
import { Description } from "../metadata/Description";
import { Title } from "../metadata/Title";
import { transformExifData } from './utils';

import { state } from './context';
import { caption_source } from '../settings';

export const initCaption = (lightbox, infos_to_display) => {
  lightbox.on('uiRegister', () => {
    lightbox.pswp.ui.registerElement({
      name: 'custom-caption',
      order: 9,
      isButton: false,
      appendTo: 'root',
      html: '',
      onInit: (el, pswp) => {

        lightbox.pswp.on('zoomPanUpdate', (e) => {
          if (e.slide === pswp.currSlide) {
            const zoom = Math.round(pswp.currSlide.currZoomLevel * 100);
            if ( !state.defaultZoomLevel[pswp.currSlide.index] ) {
              state.defaultZoomLevel[pswp.currSlide.index] = zoom;
            } else if ( zoom > state.defaultZoomLevel[pswp.currSlide.index] ) {
              el.style.opacity = 0;
            } else {
              el.style.opacity = 1;
            }
          }
        });

        lightbox.pswp.on('change', () => {
          const image = lightbox.pswp.currSlide.data;
          const exifData = transformExifData(image, infos_to_display);

          const caption_text = image.caption || (image.meta && image.meta.caption);
          const description_text = image.description || (image.meta && image.meta.description);
          const caption = caption_source === 'description' ? description_text : caption_text;
          image.caption = caption;

          const title = (image.exifs && image.exifs.title) || (image.meta && image.meta.title);

          const shouldDisplayTitleOrCaption =
            (infos_to_display.title && title) ||
            (infos_to_display.caption && caption);

          if ((exifData.length === 0 && !shouldDisplayTitleOrCaption) || state.isMapView) {
            el.style.display = 'none';
            return;
          }

          const captionHTML = (
            <div className="mwl__metadata">
              {infos_to_display.title && <Title image={image} />}
              {infos_to_display.caption && <Description image={image} />}
              {!infos_to_display.caption && !infos_to_display.title && (
                <div style={{ height: '20px', width: '1px', overflow: 'hidden' }}></div>
              )}
              <div className="exifs">
                {exifData.map(v => <ExifComponent {...v} />)}
              </div>
            </div>
          );

          render(captionHTML, el);
        });
      },
    });
  });
};